import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import AdminBottomNav from "../layout/AdminBottomNav";

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      {/* Sidebar */}
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />

      {/* Overlay for small screens */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-30 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main (offset on desktop to avoid being hidden by fixed sidebar) */}
      <div className="flex min-h-screen flex-col min-w-0 md:pl-64">
        <Header onMenuClick={() => setSidebarOpen((v) => !v)} />

        {/* top padding for fixed header + bottom padding for mobile bottom nav */}
        <main className="flex-1 overflow-y-auto p-3 sm:p-4 pt-20 md:pt-16 pb-24 md:pb-4">
          <Outlet />
        </main>

        {/* Desktop footer only */}
        <div className="hidden md:block">
          <Footer />
        </div>

        {/* Mobile bottom nav */}
        <AdminBottomNav onOpenMenu={() => setSidebarOpen(true)} />
      </div>
    </div>
  );
}
